
riot.tag2('permissions-roles-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Роли</div>\n    </yield>\n    <yield to="body">\n      <catalog object="PermissionRole" cols="{cols}" disable-col-select="true" store="permissions-roles-list-modal" dblclick="{parent.opts.submit.bind(this)}" disable-limit="true">\n        <yield to="body">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    self.tags['bs-modal'].cols = [{ name: 'name', value: 'Наименование' }];
});
});


// WEBPACK FOOTER //
// ./pages/settings/permissions/permissions-roles-list-modal.tag